import React from 'react';

const GenericDataContext = React.createContext({

    polkoClientes: false,
    idPaginaPolkista: null,
    idPolkista: null

});

export default GenericDataContext;